// Lightweight global impersonation state (feature #6). The ImpersonationBanner
// polls /api/impersonate/status and publishes the result here so useRole() and
// the shell can switch into the impersonated tenant's view while a superadmin
// is impersonating — without threading props through the whole tree.
import { useEffect, useState } from "react";

let state = { active: false, role: null, user: null, company: null };
const listeners = new Set();

export function getImpersonation() {
  return state;
}

export function setImpersonation(next) {
  state = next || { active: false, role: null, user: null, company: null };
  listeners.forEach((l) => l(state));
}

export function useImpersonation() {
  const [s, set] = useState(state);
  useEffect(() => {
    listeners.add(set);
    set(state);
    return () => listeners.delete(set);
  }, []);
  return s;
}
